<template>
  <div>
    <input type="text" v-model="person.name" placeholder="Search people" v-on:input="debouncedHandler" />
    <div class='wrapper'>
      <div v-for='person in people' :key='person'>
        <div class='site'>
          <p>{{ person.last }}</p>
          <p>{{ person.first }}</p>
          <a @click='deletePerson(person)'>Delete</a>
        </div>
      </div>
      <PersonForm/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PersonForm from '@/components/Directory/PersonForm.vue'
import debounce from 'lodash.debounce'

export default {
  name: 'Person',
  data () {
    return {
      person: {
        name: ''
      }
    }
  },
  computed: {
    ...mapGetters(['people'])
  },
  components: {
    PersonForm
  },
  created () {
    this.debouncedHandler = debounce(event => {
      console.log('New value:', event.target.value)
      this.$store.dispatch('searchPeople', { last: this.person.name, first: '' })
    }, 600)
  },
  beforeUnmount () {
    this.debouncedHandler.cancel()
  },
  methods: {
    deletePerson (person) {
      this.$store.dispatch('deletePerson', { username: person.username })
    }
    // ,
    // mayDelete (user) {
    //   return !user.username.startsWith('!')
    // }
  }
}
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&display=swap");

input {
  display: block;
  width: 350px;
  margin: 20px auto;
  padding: 10px 45px;
  background: white url("../../assets/search-icon.svg") no-repeat 15px center;
  background-size: 15px 15px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}

.item {
  width: 350px;
  margin: 0 auto 10px auto;
  padding: 10px 20px;
  color: white;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,
    rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
}

.person {
  background-color: rgb(97, 62, 252);
  cursor: pointer;
}

.error {
  background-color: tomato;
}

.site {
  border: 3px solid;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1rem;
}

.site p:first-child {
  font-weight: bold;
  font-size: 2.5rem;
  margin: 1rem 0;
}

.site p:last-child {
  font-style: italic;
  font-size: 0.8rem;
}
</style>
